import { dataRow } from './../../../booking/booking-detail/booking-detail-fluvaccine.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { BaseService } from '../../../../shared/services/base.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { ValidationService } from '../../../../shared/services/validation.service';
import { Utility } from '../../../../common/utility';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../.././../../shared/constants/constants';
import { Page } from '../../../../models/list/page.model';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { UserUrl } from '../../../../shared/urls/user.url';

import { InvoiceListModel, SearchType, CentreGroup } from '../../../../models/payment/invoice.model';
import { AccountPaymentService } from '../account-payment.service';
import { AddOrderPopupComponent } from './add-order-popup.component';
import { RefundPopupComponent } from './refund-popup.component';
import { CreditNotePopupComponent } from './credit-note-popup.component';

import { CurrencyNumberPipe } from '../../../../pipes/currency-number.pipe';
import { SharedService } from '../../../../shared/services/share.services';
import { TMBDataTableComponent } from '../../../../components/data-table/data-table.component';
import { UserType } from '../../../../shared/constants/permission';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'list-invoice',
  templateUrl: './list-invoice.component.html',
  providers: [AccountPaymentService, CurrencyNumberPipe]
})

export class ListInvoiceComponent extends TMBDataTableComponent implements OnInit {
  @Input() listcreditnote;
  @Input() payinvoice;
  @Input() patientId;
  
  public filterInvoiceForm: FormGroup;

  public dataRow = new Array<InvoiceListModel>();
  public isSearch = false;
  public invoiceId: any;
  public navigateUrl = 'consultation/cash-sale';
  public patientInfo;
  public infoOrganization: any;
  public searchPatientId: string;
  public filterCentreName: string;
  public filterData = {
    searchType: null,
    organizationId: null,
    centreId: null,
    invoiceNo: '',
    dateFrom: '',
    dateTo: '',
    showAllInvoice: false,
    showAllCredit: false,
    isGroup: false,
    currency: ''    
  };

  public searchType = {
    isIndividual: true,
    isOrganization: false,
    isHoldingTax: false,
  };

  public holdTax = false;
  public selectedAmountOpen = 0;
  public totalAmountAllocated = 0;
  public minAmountOpen = 0;
  public selectedTax = 0;

  // array data invoice checked
  public dataChecked = [];
  public listSearchType: any[];
  public listOrganization: any[];
  public listCentres = new Array<CentreGroup>();;
  public listCurrency: any[];
  public invoiceData;
  public feeData = [];
  public currencyData = [];

  // currency Model
  public selectedCurrency: any = {
    code: '',
    id: '',
    symbol: '',
    symbolPosition: '',
    rate: 1
  };

  private reportTokenId: string;
  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    public router: Router,
    public baseService: BaseService,
    public shareServices: SharedService,
    public dialogService: DialogService,
    private activeRouter: ActivatedRoute,
    public sharedService: SharedService,
    public accountPaymentService: AccountPaymentService) {
    super(sharedService);
    this.createForm();
    this.reportTokenId = this.utility.randomKey();
  }

  ngOnInit() {
    // Patient Id from search patitent page
    this.patientId = this.activeRouter.snapshot.queryParams['patientId'] == null ?
      '' : this.activeRouter.snapshot.queryParams['patientId'];

    if (localStorage.getItem(AppConstants.localStorage.isBaseClinic) !== 'true'
      && localStorage.getItem(AppConstants.localStorage.userType) !== UserType.SystemAdmin) {
      this.filterInvoiceForm.controls['centreId'].disable();
    }
    this.getSearchType();
    this.getCurrency();
    console.log(this.patientId);
    if(this.patientId!=null)
    {
      this.setPage({ offset: 0 });
      this.getUserInfo();
    }
    //this.getUserInfo();
  }

  createForm() {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    this.filterInvoiceForm = this.formBuilder.group({
      searchType: '',
      organizationId: [''],
      centreId: '',
      invoiceNo: ['', [Validators.required]],
      fromDate: [],
      toDate: []
    });
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  searchInvoiceByPatientId(){
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      searchType: 0,     
      centreId: this.filterData.centreId,      
      patientId: this.patientId,   
      isShowAll: false,
      showAllCredit: false      
    };

    // call API
    this.accountPaymentService.getInvoiceList(param).subscribe(result => {
      if (result) {
        const data = result.json();
        this.dataRow = data['list'];
        // update data payment
        this.payinvoice.setPage({ offset: 0 });

        // Update data list
        this.updateData();

        this.payinvoice.dataCalculate = data['calculate'];
        // this.dataRow[0].invoiceId;
        this.page.totalElements = data['totalRecords'];
        if (this.page.totalElements > 0) {
          this.invoiceId = this.dataRow[0]['id'];
        }
        this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);

        // fix paging in withholding tax
        if ((this.page.pageNumber + 1) > this.page.totalPages) {
          this.page.pageNumber = this.page.totalPages - 1;
        }

        this.resetData();
      }
    });
  }

  setPage(pageInfo) {
    if (!pageInfo) {
      return;
    }
    if (this.filterData.searchType != SearchType.WithholdingTax) {
      this.page.pageNumber = pageInfo.offset;
    }
    var fromDate = null;
    if(this.filterInvoiceForm.controls['fromDate'].value !== null)
    {
      fromDate = this.utility.convertDateToString(new Date(this.filterInvoiceForm.controls['fromDate'].value));
    }
    var toDate = null;
    if(this.filterInvoiceForm.controls['toDate'].value !== null)
    {
      toDate = this.utility.convertDateToString(new Date(this.filterInvoiceForm.controls['toDate'].value));
    }
    const url = UserUrl.GET_CENTRE_USERS;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      searchType: this.filterData.searchType,
      organizationId: this.filterData.organizationId,
      centreId: this.filterData.centreId,
      invoiceNumber: this.filterData.invoiceNo.trim(),
      patientId: this.patientId,
      from: fromDate,
      to: toDate,
      isShowAll: this.filterData.showAllInvoice,
      showAllCredit: this.filterData.showAllCredit,
      isGroup: this.filterData.isGroup,
      currencyCode: this.filterData.currency
    };

    // call API
    this.accountPaymentService.getInvoiceList(param).subscribe(result => {
      if (result) {
        const data = result.json();
        this.dataRow = data['list'];
        // update data payment
        this.payinvoice.setPage({ offset: 0 });

        // Update data list
        this.updateData();

        this.payinvoice.dataCalculate = data['calculate'];
        // this.dataRow[0].invoiceId;
        this.page.totalElements = data['totalRecords'];
        if (this.page.totalElements > 0) {
          this.invoiceId = this.dataRow[0]['id'];
        }
        this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);

        // fix paging in withholding tax
        if ((this.page.pageNumber + 1) > this.page.totalPages) {
          this.page.pageNumber = this.page.totalPages - 1;
        }

        this.resetData();
      }
    });

    if (this.filterData.searchType == SearchType.Organization) {
      this.accountPaymentService.getOrganizationDetail(this.filterData.organizationId).subscribe(
        result => {
          if (result) {
            this.infoOrganization = result.json();
          }
        }
      );
    }

    this.isSearch = true;
  }

  onFilter() {
    this.searchPatientId = null;
    if (this.filterInvoiceForm.valid && this.filterInvoiceForm.dirty) {
      this.setPage({ offset: 0 });
      this.getUserInfo();
    }
  }

  /**
   * on input from date input event
   * @param event
   */
  onFromDateInput(event) {
    // ValidationService.validationDate(this.filterInvoiceForm.controls['fromDate'], event);
  }

  /**
   * on change from date input event : format the date and set
   * @param event
   */
  onFromDateChange(event) {
    this.accountPaymentService.validateDateRange(this.filterInvoiceForm.controls['fromDate'],
      this.filterInvoiceForm.controls['toDate'], true);
  }

  /**
   * on input from date inpput event
   * @param event
   */
  onToDateInput(event) {
    // ValidationService.validationDate(this.filterInvoiceForm.controls['toDate'], event);
  }

  /**
   * on change from date input event : format the date and set
   * @param event
   */
  onToDateChange(event) {
    this.accountPaymentService.validateDateRange(this.filterInvoiceForm.controls['fromDate'],
      this.filterInvoiceForm.controls['toDate'], false);
  }

  onCentreChange(){
    this.filterData.isGroup = this.listCentres.find(tmp => tmp.id === this.filterData.centreId).isGroup
  }

  /**
   * Show report Payment Received
   */
  onSearchTypeChange() {
    this.resetAll();
    if (this.filterData.searchType == SearchType.Organization) {
      this.searchType.isOrganization = true;

      this.accountPaymentService.getListOrganization().subscribe(
        result => {
          if (result) {
            const data = result.json();
            this.listOrganization = data;
          }
        }
      );
      this.accountPaymentService.getCentreGroup().subscribe(
        result => {
          if (result) {
            const data = result.json();
            this.listCentres = data;
            this.filterData.centreId = localStorage.getItem(AppConstants.localStorage.centreId);
          }
        }
      );
      ValidationService.attachRequired(this.filterInvoiceForm.controls['organizationId'], []);
    } else {
      ValidationService.removeRequired(this.filterInvoiceForm.controls['organizationId'], []);
      this.searchType.isOrganization = false;
      
      
    }

    if (this.filterData.searchType == SearchType.WithholdingTax) {
      this.setPage({ offset: 0 });
      this.searchType.isHoldingTax = true;
    } else {
      this.searchType.isHoldingTax = false;
    }

    if (this.filterData.searchType == SearchType.Individual) {
      this.searchType.isIndividual = true;
      ValidationService.attachRequired(this.filterInvoiceForm.controls['invoiceNo'], []);
    } else {
      this.searchType.isIndividual = false;
      ValidationService.removeRequired(this.filterInvoiceForm.controls['invoiceNo'], []);
    }
    // this.accountPaymentService.setSearchType(this.searchType);
  }

  resetAll() {
    this.isSearch = false;
    this.filterData.invoiceNo = '';
    this.filterData.dateFrom = null;
    this.filterData.dateTo = null;
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if(this.filterData.searchType == SearchType.Organization)
    {
      this.filterData.dateFrom = this.utility.convertDateToString(new Date(currentDate));
      this.filterData.dateTo = this.utility.convertDateToString(new Date(currentDate));
    }
    this.dataRow = [];
    this.resetData();
  }

  resetData() {
    this.dataChecked = [];
    this.selectedAmountOpen = 0;
    this.selectedTax = 0;
    this.payinvoice.paymentForm.controls['total'].setValue(0);
    this.payinvoice.paymentForm.controls['value'].setValue(0);
    this.payinvoice.paymentForm.controls['type'].setValue(null);
    this.payinvoice.paymentFormTax.controls['total'].setValue(0);
    // const currentDate = new Date();
    // currentDate.setHours(0, 0, 0, 0);
    // if(this.filterData.searchType == SearchType.Organization)
    // {
    //   this.filterData.dateFrom = this.utility.convertDateToString(new Date(currentDate));
    //   this.filterData.dateTo = this.utility.convertDateToString(new Date(currentDate));
    // }
  }
  /**
   * Show report Statement
   */
  onMergeInvoice() {
    const invoiceCheckedLength = this.dataChecked.length;
    if (invoiceCheckedLength) {
      const reportName = 'InvoicesMerged';
      const invoices = new Array<string>();
      this.dataChecked.forEach(item => {
        invoices.push(item.id);
      });

      const params = {
        [AppConstants.reportParameter.currency]: this.filterData.currency,
        [AppConstants.reportParameter.selectedInvoices]: invoices,
        [AppConstants.reportParameter.pdfprintType]: 'pdf'
      };

      this.shareServices.showReport(reportName, params);

    } else {
      this.dialogService.openErrorDialog({ message: AppMessages.payment.errorMergeInvoice });
    }
  }

  /**
     * Show form to input Refund note, and amount
     * @param
     */
  onAddNewCredit() {
    const invoiceCheckedLength = this.dataChecked.length;  

    if (invoiceCheckedLength > 0) {
      // check invoice full paid
      // const invoiceId[] = this.dataChecked[0]['id'];
      // const amountOpen = this.dataChecked[0]['amountOpen'];

      const invoices = new Array<string>();   
      this.minAmountOpen = this.dataChecked[0]['amountOpen'];

      this.dataChecked.forEach(item => {
        invoices.push(item.id);        
        this.minAmountOpen = (item.amountOpen < this.minAmountOpen ? item.amountOpen : this.minAmountOpen);
      });
      this.totalAmountAllocated += this.minAmountOpen*invoiceCheckedLength;

      if (this.minAmountOpen === 0) {
        this.dialogService.openErrorDialog({ message: AppMessages.payment.errorAddFullyPaid });
      } else {
        // this.accountPaymentService.allocateCreditNote(invoiceId, creditNoteId).subscribe(
        //   result => {
        //     if (result) {
        //       this.setPage({ offset: 0 });
        //     }
        //   }
        // );
        const data = {
          invoiceIds: invoices,
          totalAmountAllocated: this.totalAmountAllocated,
          maxAllocatedAmount : this.minAmountOpen,
          currencyCode: this.filterData.currency,
          countOfInvoices: invoiceCheckedLength
        };
        this.dialogService
          .openComponentDialog(CreditNotePopupComponent, data)
          .subscribe(result => {
            if (result) {
              // Success Message
              this.dialogService.openSuccessDialog({ message: AppMessages.payment.successAllocate });
              this.setPage({ offset: 0 });
            }
          });
      }
    } else {
      this.dialogService.openErrorDialog({ message: AppMessages.payment.errorAddCreditNote });
    }
  }

  /**
   * Show report Statement
   */
  showStatement() {
    const from =  this.filterInvoiceForm.controls['fromDate'].value? this.utility.convertDateToString(new Date(this.filterInvoiceForm.controls['fromDate'].value)) : null;
    const to =  this.filterInvoiceForm.controls['toDate'].value? this.utility.convertDateToString(new Date(this.filterInvoiceForm.controls['toDate'].value)) : null ;
    const reportName = 'Statement';
    const params = {
      [AppConstants.reportParameter.selectedClinicId]: !this.filterData.isGroup? this.filterData.centreId : null ,
      [AppConstants.reportParameter.groupId]: this.filterData.isGroup? this.filterData.centreId : null,
      [AppConstants.reportParameter.selectedClinicName]: localStorage.getItem(AppConstants.localStorage.centreName),
      [AppConstants.reportParameter.startDate]: from,
      [AppConstants.reportParameter.endDate]: to,
      [AppConstants.reportParameter.currency]: this.filterData.currency,
      [AppConstants.reportParameter.orgCode]: this.filterData.organizationId,
      [AppConstants.reportParameter.selectedOrganisationId]: this.filterData.organizationId,
      
      [AppConstants.reportParameter.pdfprintType]: 'pdf'
    };

    this.shareServices.showReport(reportName, params);
  }

  /**
   * Allow to fill in order number for the selected invoice
   */
  onAddOrder() {
    const invoiceCheckedLength = this.dataChecked.length;
    const data = {
      invoiceSelected: this.dataChecked
    };
    if (invoiceCheckedLength) {
      this.dialogService.openComponentDialog(AddOrderPopupComponent, data).subscribe(
        result => {
          //this.resetData();
        }
      );
    } else {
      this.dialogService.openErrorDialog({ message: AppMessages.payment.errorAddOrder });
    }
  }


  /**
   * Show report Payment Received
   */
  showPaymentReceived() {
    const invoices = new Array<string>();
    this.dataChecked.forEach(item => {
	  invoices.push(item.id);    });

     if (this.filterData.searchType == 0 && !invoices.length) { // search Type = Invidual
      this.dialogService.openErrorDialog({ message: AppMessages.payment.errorAddOrder });
     } else {
      var fromDate = null;
      if(this.filterInvoiceForm.controls['fromDate'].value != null)
        fromDate = this.utility.convertDateToString(new Date(this.filterInvoiceForm.controls['fromDate'].value));
      var toDate = null;
      if(this.filterInvoiceForm.controls['toDate'].value != null)
        toDate = this.utility.convertDateToString(new Date(this.filterInvoiceForm.controls['toDate'].value));
      const reportName = 'PaymentsReceived';
      const selectedOrganization = this.filterData.organizationId;
      const selectedClinic = this.findCentre(this.listCentres, this.filterData.centreId).name;
      const params = {
        [AppConstants.reportParameter.selectedClinicId]: this.filterData.centreId,
        [AppConstants.reportParameter.startDate]: fromDate,
        [AppConstants.reportParameter.endDate]: toDate,
        [AppConstants.reportParameter.InvoiceNo]: this.filterData.searchType == 0 ? invoices[0] : null,
        [AppConstants.reportParameter.selectedOrganisationId]: this.filterData.organizationId,
        // [AppConstants.reportParameter.selectedPatient]: this.filterData.searchType == 0 ? this.dataChecked[0].patientREF : null,
        [AppConstants.reportParameter.currency]: this.filterData.currency,
        [AppConstants.reportParameter.selectedInvoices]: this.filterData.searchType == 0 ? null : invoices,
        [AppConstants.reportParameter.pdfprintType]: 'pdf',
        [AppConstants.reportParameter.selectedClinicName]: this.filterData.searchType == 0 ? localStorage.getItem(AppConstants.localStorage.centreName) : selectedClinic
      };

      this.shareServices.showReport(reportName, params);
     }
  }

  // Find Centre in Group centre
  findCentre(groups, centreId) {
    let centreSelect = {
      id: null,
      name: ''
    };
    groups.forEach(group => {
      if (group.id == centreId) {   
            centreSelect = group;
      }
    });
    return centreSelect;
  }

  /**
     * Show Report Invoice
     * @param string invoiceId
     */
  showInvoiceReport(invoiceId) {
    const reportName = 'Invoice';
    const params = {
      [AppConstants.reportParameter.currency]: this.filterData.currency,
      [AppConstants.reportParameter.InvoiceNo]: invoiceId,
      [AppConstants.reportParameter.pdfprintType]: 'pdf'
    };

    this.shareServices.showReport(reportName, params);
  }

  /**
   * Show invoices including fully paid invoices
   */
  onshowAllInvoice(event) {
    this.setPage({ offset: 0 });
  }

  /**
     * Save the inputted withhold tax, reg no and security
     * @param
     */
  onSaveInputted(data) {
    const invoiceId = data.id;
    const param = {
      withholdingTax: this.convertString(data.withholdTax),
      registrationNumber: data.regNo,
      security: data.security,
      currencyCode: this.filterData.currency
    };
    // const withholdTax = data.withholdTax;
    // const regNo = data.regNo;
    // const security = data.security;
    if (param.withholdingTax !== '' && param.withholdingTax !== null && param.registrationNumber && param.security) {
      if (param.withholdingTax > data.amountOpen) {
        this.dialogService.openErrorDialog({ message: AppMessages.payment.errorWithholdTax });
        return;
      }
      if (param.withholdingTax < 0) {
        this.dialogService.openErrorDialog({ message: AppMessages.payment.errorWithholdTaxType });
        return;
      }

      this.accountPaymentService.updateWithHoldingTax(invoiceId, param).subscribe(
        result => {
          if (result) {
            this.setPage({ offset: 0 });
          }
        }
      );
    } else {
      this.dialogService.openErrorDialog({
        message: Utility.stringFormat(AppMessages.payment.errorSaveRequired, [data.invoiceNumber])
      });
    }

  }

  /**
     * Allow to mark bad debt for the selected invoice
     * @param
     */
  onBadDebt(invoiceId) {
    if (invoiceId) {
      this.accountPaymentService.updateBadDebt(invoiceId).subscribe(
        result => {
          if (result) {
            this.setPage({ offset: 0 });
          }
        }
      );
    }
  }

  /**
     * Navigate to cash sale page
     * @param
     */
  onEditInvoice(invoiceId) {
    this.router.navigate([this.navigateUrl],
      {
        queryParams:
          {
            invoiceId: invoiceId,
            isPayment: true,
            editInvoice: true,
          }
      });
  }

  /**
     * Show form to input Refund note, and amount
     * @param
     */
  onRefund(row) {
    const data = {
      invoiceId: row.id,
      invoiceTotal: row.invoiceTotal
    };
    this.dialogService.openComponentDialog(RefundPopupComponent, data).subscribe(
      result => {
        if (result) {
          this.setPage({ offset: 0 });
        }
      }
    );
  }

  /**
     * Count SelectTotal and Get all selected invoice to array
     * @param data row invoice
     */
  onCheckedRow(data, event) {
    if (event.checked) {
      // push data invoice to array if it checked
      this.dataChecked.push(data);
    } else {
      // find and remove data invoice from array if it no checked
      this.dataChecked.splice(this.dataChecked.indexOf(data), 1);
    }

    if (!this.searchType.isHoldingTax) {
      // calculate total amount open
      this.selectedAmountOpen = 0;
      this.dataChecked.forEach(item => {
        this.selectedAmountOpen += item.amountOpen;
        this.selectedAmountOpen = this.roundPriceNumber(this.selectedAmountOpen);
      });
      this.payinvoice.paymentForm.controls['total'].setValue(this.selectedAmountOpen);
    } else {
      // calculate pay Withholding Tax
      this.selectedTax = 0;
      this.dataChecked.forEach(item => {
        this.selectedTax += item.withholdTax;
        this.selectedTax = this.roundPriceNumber(this.selectedTax);
      });
      this.payinvoice.paymentFormTax.controls['total'].setValue(this.selectedTax);
    }
  }

  // ===========================
  getSearchType() {
    this.accountPaymentService.getSearchType().subscribe(result => {
      if (result) {
        const data = result.json();
        this.listSearchType = data;
        // Default search type
        this.filterData.searchType = 0;
      }
    });
  }

  getCurrency() {
    this.accountPaymentService.getCurrencies().subscribe(result => {
      if (result) {
        const data = result.json();
        this.listCurrency = data;

        // Default currency
        this.filterData.currency = 'EUR';
        this.accountPaymentService.getDefaultCurrency(localStorage.getItem(AppConstants.localStorage.centreId)).subscribe(
          resultCentre => {
            if (resultCentre) {
              const dataCentre = resultCentre.json();
              this.filterData.currency = this.listCurrency.find(c => c.id == dataCentre['currencyId']).code;
              this.updateSelectedCurrency(this.filterData.currency);

              // Search Account Payment by PatientId
              if (this.searchPatientId) {
                this.setPage({ offset: 0 });
                // Get user information
                this.accountPaymentService.getUserInfor({ patientId: this.searchPatientId }).subscribe(result => {
                  if (result) {
                    const dataUser = result.json();
                    this.patientInfo = dataUser['patientInfo'];
                  }
                });
              }
            }
          }
        );
      }
    });
  }

  getUserInfo() {
    const param = {
      invoiceNo: this.filterData.invoiceNo,
      patientId: this.patientId
    };

    this.accountPaymentService.getUserInfor(param).subscribe(result => {
      if (result) {
        const data = result.json();
        this.patientInfo = data['patientInfo'];
      }
    });
  }

  getRowClass(row) {
    return {
      'isBadDebt': row.isBadDebt
    };
  }

  /**
   * Call when change currency
   */
  onChangeCurrency() {
    this.updateSelectedCurrency(this.filterData.currency);
    this.setPage({ offset: 0 });
  }

  /**
   * On update data list
   */
  updateData() {
    // Update data list when change currency rate
    for (let i = 1; i < this.dataRow.length; i++) {
      this.dataRow[i]['balance'] = this.roundPriceNumber(this.dataRow[i]['balance'] + this.dataRow[i - 1]['balance']);
    }
  }
  /**
	 * update selectedCurrency model when user change currency
	 * @param currencyId String : currency Id that user selected in Currency select box
	 */
  updateSelectedCurrency(currencyCode) {
    const currency = this.listCurrency.filter(c => c.code === currencyCode);
    if (currency.length > 0) {
      this.selectedCurrency = currency[0];
      this.payinvoice.selectedCurrency = currency[0];
    }
  }

  /**
 * Convert number for directive appCurrencyNumber
 * @param control
 */
  convertString(value) {
    if (value) {
      if (typeof value === 'string' && value.includes('.')) {
        if (value.split('.')[1].length === 3) {
          value = value.slice(0, -1);
        }
      }
      return value.toString();
    } else {
      return value;
    }
  }

  roundPriceNumber(num) {
    return Math.round(num * 100) / 100;
  }

  onCheckWithHoldTax(event) {
    if (event.checked) {
      this.updateTableLayout();
    } else {
      this.setPage({ offset: 0 });
    }
  }

  setWithHoldingTaxPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/account-payment/list-invoice/list-invoice.component.ts